import * as yup from "yup";

export const lastSmokedSchema = yup
  .object()
  .shape({
    smokedIn48h: yup.string().required("Please provide an answer"),
  })
  .required();
